import { Icon } from '../components/Icon';
import { PARTNERSHIP_TYPES } from '../content/site';

export function PartnershipTypes() {
  return (
    <section id="partnership-types" className="section bg-white">
      <div className="container-content">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow">Partnership types</span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-ink-900 sm:text-4xl">
            Find the way you want to partner
          </h2>
          <p className="mt-4 text-lg text-ink-500">
            From sponsoring a full prize to driving foot traffic or promoting through creators —
            choose the model that fits your goals.
          </p>
        </div>

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {PARTNERSHIP_TYPES.map((type) => (
            <li
              key={type.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-line bg-white shadow-card transition-shadow duration-200 hover:shadow-card-hover"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-aurora-soft">
                <img
                  src={type.image}
                  alt={`${type.title} — illustration`}
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover transition-transform duration-300 motion-safe:group-hover:scale-105"
                />
                <span className="absolute bottom-3 left-3 grid h-11 w-11 place-items-center rounded-xl bg-white/90 text-primary-700 shadow-card backdrop-blur">
                  <Icon name={type.icon} className="h-6 w-6" />
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-heading text-lg font-semibold text-ink-900">{type.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-ink-700">{type.blurb}</p>
                <p className="mt-4 border-t border-line pt-4 text-sm text-ink-500">
                  <span className="font-semibold text-primary-700">Example: </span>
                  {type.example}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default PartnershipTypes;
